import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Col, Row } from "styles";
import { Table } from "../../style";

export function EnziPacProProtease(props) {
  return (
    <>
      <Row>
        <Col>
          <Table>
            <Header>
              <tr>
                <th style={{ width: "185px" }}>
                  <span></span>
                </th>
                <th>
                  <span>Qual produto?</span>
                </th>
                <th>
                  <span>Qual finalidade?</span>
                </th>
                <th>
                  <span>Qual dose?</span>
                </th>
              </tr>
            </Header>
            <Body>
              <tr>
                <td>Pré</td>

                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.enziPacProProtease.pre.product"
                    item={props.broiler}
                    setItem={props.setBroiler}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.enziPacProProtease.pre.goal"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.enziPacProProtease.pre.dose"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
              </tr>
              <tr>
                <td>Inicial</td>

                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.enziPacProProtease.initial.product"
                    item={props.broiler}
                    setItem={props.setBroiler}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.enziPacProProtease.initial.goal"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.enziPacProProtease.initial.dose"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
              </tr>
              <tr>
                <td>Crescimento 1</td>

                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.enziPacProProtease.growth.product"
                    item={props.broiler}
                    setItem={props.setBroiler}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.enziPacProProtease.growth.goal"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.enziPacProProtease.growth.dose"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
              </tr>
              <tr>
                <td>Crescimento 2</td>

                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.enziPacProProtease.growth2.product"
                    item={props.broiler}
                    setItem={props.setBroiler}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.enziPacProProtease.growth2.goal"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.enziPacProProtease.growth2.dose"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
              </tr>
              <tr>
                <td>Final</td>

                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.enziPacProProtease.final.product"
                    item={props.broiler}
                    setItem={props.setBroiler}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.enziPacProProtease.final.goal"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="enzymes.enziPacProProtease.final.dose"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
              </tr>
            </Body>
          </Table>
        </Col>
      </Row>
      <Row>
        <Col>
          <label>EnzyPac está aprovado? Se não, por qual motivo?</label>
          <Input
            type="checkbox"
            params="enzymes.enziPacProProtease.approved.checked"
            item={props.broiler}
            setItem={props.setBroiler}
            label="Aprovado"
          />
          <Input
            type="input"
            label=" "
            params="enzymes.enziPacProProtease.approved.reason"
            item={props.broiler}
            setItem={props.setBroiler}
            disabled={props.broiler.enzymes.enziPacProProtease.approved.checked}
            placeholder="Digite o motivo"
          />
        </Col>
      </Row>
    </>
  );
}
